import { Grid, GridAreas, StyledFlex, StyledMargin } from '@dreryk/react-components';

type SentMagistralDrugPrescriptionGridProps = {
   readonly dosage: JSX.Element;
   readonly issuedFrom: JSX.Element;
   readonly quantity: JSX.Element;
   readonly issuedTo: JSX.Element;
   readonly activeIngredients: JSX.Element;
   readonly additionalEntitlementTypes: JSX.Element;
   readonly additionalRequirementTypes: JSX.Element;
   readonly prescriptionCategory: JSX.Element | undefined;
};

type AREA =
   | 'dosage'
   | 'issuedFrom'
   | 'afterIssuedFrom'
   | 'additionalEntitlementTypes'
   | 'additionalRequirementTypes'
   | 'prescriptionCategory';

const useAreas = (prescriptionCategory?: boolean): GridAreas<AREA> => ({
   small: {
      template: [
         'dosage dosage dosage',
         'issuedFrom afterIssuedFrom afterIssuedFrom',
         `additionalEntitlementTypes additionalRequirementTypes ${
            prescriptionCategory ? 'prescriptionCategory' : 'additionalRequirementTypes'
         }`,
      ],
   },
});

export const SentMagistralDrugPrescriptionGrid = (props: SentMagistralDrugPrescriptionGridProps): JSX.Element => {
   return (
      <Grid<AREA>
         areas={useAreas(Boolean(props.prescriptionCategory))}
         testId={'sentMagistralDrugPrescription'}
         compact
         dosage={props.dosage}
         issuedFrom={props.issuedFrom}
         afterIssuedFrom={
            <StyledFlex direction={'row'} gap={'8px'}>
               <StyledFlex flex={'1'}>{props.quantity}</StyledFlex>
               <StyledFlex direction={'column'} gap={'2px'} alignItems={'center'} flex={'192px 0 0'}>
                  <StyledMargin top={18}>
                     {props.issuedTo}
                     {props.activeIngredients}
                  </StyledMargin>
               </StyledFlex>
            </StyledFlex>
         }
         additionalEntitlementTypes={props.additionalEntitlementTypes}
         additionalRequirementTypes={props.additionalRequirementTypes}
         prescriptionCategory={props.prescriptionCategory}
      />
   );
};
